<template>
  <div class="field-adder d-flex mb-4">
    <b-form-input
      :placeholder="placeholder || `Enter ${label}`"
      :type="type"
      :value="value"
      @input="onInput"
    >
    </b-form-input>
    <div class="action ml-4">
      <button class="btn btn-danger" @click="onRemove">
        <i class="text-light fa fa-trash" />
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: "text",
    },
    label: {
      type: String,
    },
    placeholder: {
      type: String,
    },
    value: {
      type: String,
      required: true,
    },
    last: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onInput(value) {
      this.$emit("input", value);
    },
    onRemove(e) {
      e.preventDefault();
      this.$emit("remove");
    },
  },
};
</script>
